const whiteListRouteNames: Array<string> = ['login', 'reset-password'];

export default async (router, store) => {
  // Проверка авторизации
  router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters['auth/isAuthenticated'];
    if (whiteListRouteNames.indexOf(to.name) !== -1 || isAuthenticated) {
      next();
    } else {
      router.push({ name: 'login' });
    }
  });
};
